import React, { useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Reviews } from '../../components';
import pic from '../../assets/profile.png';

import css from './ListingPage.css';
import ratingCss from './rating.css';

const SectionReviews = props => {
 var { reviews, fetchReviewsError, googleReviews, rating } = props;
  const [googleReviewData,setGoogleReviewData] = useState(false);
  let btn = <span className={ratingCss.blueBtn} onClick={() => setGoogleReviewData(true)}><FormattedMessage id="faq.q10.a.link" /></span>
  let stars = 0;
  const reviewsError = (
    <h2 className={css.errorText}>
      <FormattedMessage id="ListingPage.reviewsError" />
    </h2>
  );
  const reviewsExist = reviews.length ?? 0;
  const falseReviewsTitle = <FormattedMessage id="ListingPage.reviewsHeadingfalseTitle" />;
  const falseReviews = <FormattedMessage id="ListingPage.reviewsHeadingfalse" />;

  function getApproxReviewRating() {
    if (rating) {
      if (rating <= 6 && rating > 5.6) {
        stars = 13;
      } else if (rating <= 5.6 && rating > 5) {
        stars = 12;
      } else if (rating <= 5 && rating > 4.6) {
        stars = 11;
      } else if (rating <= 4.6 && rating > 4) {
        stars = 10;
      } else if (rating <= 4 && rating > 3.6) {
        stars = 9;
      } else if (rating <= 3.6 && rating > 3) {
        stars = 8;
      } else if (rating <= 3 && rating > 2.6) {
        stars = 7;
      } else if (rating <= 2.6 && rating > 2) {
        stars = 6;
      } else if (rating <= 2 && rating > 1.6) {
        stars = 5;
      } else if (rating <= 1.6 && rating > 1) {
        stars = 4;
      } else if (rating <= 1 && rating > 0.6) {
        stars = 3;
      } else if (rating <= 0.6 && rating > 0) {
        stars = 2;
      } else if (rating == 0) {
        stars = 1;
      }
    }
  }
  function splitText(text) {
    if (text.length > 240 && (window.innerWidth > 450)) {
      return text.slice(0, 240) + '...';
    } else if(text.length > 145 && (window.innerWidth < 450)){
      return text.slice(0, 145) + '...';
    }else return text;
  }

  function showReviews(googleReviews) {
    if (googleReviews.length > 5) {
      for (let i = 0; i <= 5; i++) {
        return (
          <div className={ratingCss.reviewBox}>
            <div className={ratingCss.head}>
              <img className={ratingCss.authorImage} src={pic} />
              <div className={ratingCss.topBox}>
                <h3 className={ratingCss.authorName}>{googleReviews[i].author_name}</h3>
              </div>
            </div>
            <span className={ratingCss.reviewText}>{splitText(googleReviews[i].text)}</span>
            <span className={ratingCss.date}>{googleReviews[i].relative_time_description}</span>
          </div>
        );
      }
    } else {
      return googleReviews.map(review => {
        return (
          <div className={ratingCss.reviewBox}>
            <div className={ratingCss.head}>
              <img className={ratingCss.authorImage} src={pic} />
              <div className={ratingCss.topBox}>
                <h3 className={ratingCss.authorName}>{review.author_name}</h3>
              </div>
            </div>
            <span className={ratingCss.reviewText}>{splitText(review.text)}</span>
            <span className={ratingCss.date}>{review.relative_time_description}</span>
          </div>
        );
      });
    }
  }
  return (
    <div className={css.sectionReviews}>
      <h2 className={css.featuresTitle}>
        {' '}
       <FormattedMessage id="ListingPage.reviewsHeading" values={{reviewsNumber :reviewsExist }} />
      </h2>
     {!reviews.length && <div className={ratingCss.falseReviews}> {falseReviewsTitle}</div>}
      {(rating && !reviews.length) ?  <div className={ratingCss.falseReviews}> { falseReviews}</div> : null }
      {(rating&& !reviews.length) ? getApproxReviewRating() : null}
      {(rating&& !reviews.length) ? (
        <div className={ratingCss.ratings}>
          <h4 className={ratingCss.title}>
            Google reviews : {'  '}&nbsp;{' ' + rating + '  '}&nbsp;&nbsp;&nbsp;
            <div className={ratingCss.starRatingsCss} title={stars}></div>
          </h4>
        </div>
      ) : null}
      {(rating&& !reviews.length && !googleReviewData) ? <FormattedMessage id="ListingPage.viewGoogleReviewsText" values={{btn}}/> : null}
      {(googleReviewData&& !reviews.length) ?  <div className={ratingCss.reviewGoogle}>
                                      {showReviews(googleReviews)}
                                </div> : null}
      {fetchReviewsError ? reviewsError : null}
      <Reviews reviews={reviews} />
    </div>
  );
};

export default SectionReviews;
